module.exports = __webpack_public_path__ + "static/media/it.08e22ac5.jpg";